import { updateKvMarketMeta } from "./update-kv-market-meta";
import { updateMerklCampaignMeta } from "./update-merkl-campaign-meta";
import { updateRewardTokenPrice } from "./update-reward-token-price";
import { updateStaticMarkets } from "./update-static-markets";

export const Jobs = {
  updateRewardTokenPrice,
  updateKvMarketMeta,
  updateStaticMarkets,
  updateMerklCampaignMeta,
};
